(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDetailController', AgentSupplierContractDetailController);

    AgentSupplierContractDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentSupplierContract', 'AgentAccessInfo', 'AgentRequest', 'Company'];

    function AgentSupplierContractDetailController($scope, $rootScope, $stateParams, entity, AgentSupplierContract, AgentAccessInfo, AgentRequest, Company) {
        var vm = this;

        vm.agentSupplierContract = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentSupplierContractUpdate', function (event, result) {
            vm.agentSupplierContract = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
